import { Injectable } from '@angular/core';
import { createHiddenBreadcrumbs } from '@capital-access/common/breadcrumbs';
import { InternalServerErrorPageComponent } from './internal-server-error-page.component';

@Injectable()
export class InternalServerErrorPageBreadcrumbs {
  hideBreadcrumbs = createHiddenBreadcrumbs({ component: InternalServerErrorPageComponent });
}
